<template>
  <v-container fluid>
    <!-- Full-width layout container -->
    <v-row>
      <!-- A horizontal row -->

      <!-- 📍 Left Column -->
      <v-col cols="12" md="6"> <!-- Takes full width on mobile, half on desktop --> </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SettingsPage",

  computed: {},

  mounted() {},

  data() {
    return {};
  },

  methods: {},
};
</script>
